import React, { useState } from "react";
import "./styles.css";
import { isMobile } from '../../../utils';

var Tooltip = function Tooltip(props) {
  var timeout;

  var _useState = useState(false),
      active = _useState[0],
      setActive = _useState[1];

  var showTip = function showTip() {
    timeout = setTimeout(function () {
      setActive(true);
    }, props.delay || 200);
  };

  var hideTip = function hideTip() {
    clearInterval(timeout);
    setActive(false);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "tooltip__wrapper",
    onMouseEnter: showTip,
    onMouseLeave: hideTip,
    style: props.styles
  }, props.children, active && /*#__PURE__*/React.createElement("div", {
    className: "tooltip__tip " + (isMobile ? 'hidden' : 'bottom')
  }, props.title));
};

export default Tooltip;